"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.id = id;
var _keccak = require("@ethersproject/keccak256");
var _strings = require("@ethersproject/strings");
function id(text) {
  return (0, _keccak.keccak256)((0, _strings.toUtf8Bytes)(text));
}